module.exports = {};



//////////////////
// WEBPACK FOOTER
// /app/SPA/~/core-js/modules/_iterators.js
// module id = ../../../../core-js/modules/_iterators.js
// module chunks = 1